import React from "react";
import ContactForm from "./ContactForm";

function App() {
  return <ContactForm />;
}

export default App;
